import React, { Component } from 'react';
import ProgressGraph from '../commoncomponents/progressGraph';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

class SecondBox extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {

    }

    render() {
        const { percentage, name, content, progressValue, progressResponse, p1, p2 } = this.props;


        return (
            <div className="secondBox outColor">
                <div className="secondBox-container">
                    <div className="secondBox-header">
                        <div className="header1">
                            <h1>{name}</h1>
                            <div className="secondBox-icon">

                                <i className="fa fa-globe"></i>
                            </div>
                        </div>
                        <div className="header2">
                            <h2>{content}</h2>
                        </div>
                        <div className="header3">
                            <ProgressGraph
                                value={progressValue}
                                response={progressResponse}
                                color="info"
                            />
                        </div>

                    </div>


                    <div className="doughnut-section">
                        {/* <CircularProgressbar value={p1} text={`${percentage} `} /> */}
                        <CircularProgressbarWithChildren value={p1} strokeWidth={7} background

                            styles={buildStyles({
                                backgroundColor: "#fff",
                                textColor: "#17A2B8",
                                pathColor: "#17A2B8",
                                trailColor: "transparent"
                            })}>
                            <h1 className="percentageText">{percentage}</h1>
                            <div><span className="percentageBody">IN DEPOT</span></div>
                        </CircularProgressbarWithChildren>


                    </div>
                    <div className="secondBox-footer">
                        <h4>{p1}%</h4>
                        <h4>IN</h4>
                        <h4>{p2}%</h4>
                        <h4>OUT</h4>

                    </div>
                </div>

            </div>


        );
    }

}

export default SecondBox;
